import * as React from "react";
type Props = {
  className?: string,
};
function SvgStarFill({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-star-fill"
      className={className}
    >
      <mask
        id="mask0_21_1545"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_21_1545)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3L14.7812 8.92523L21 9.87539L16.5 14.4875L17.5623 21L12 17.9252L6.43769 21L7.5 14.4875L3 9.87539L9.21885 8.92523L12 3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
export default SvgStarFill;
